import { AuthenticatedUser } from "@services/user/types";
import { PermissionKey } from "./types";

export const hasNoPermission = (
  user: AuthenticatedUser,
  permissionKey: PermissionKey
) => user.role.rolePermissions[permissionKey] === "NoAccess";
